import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';
import { lastValueFrom } from 'rxjs';
import { HistorialNotificacion } from 'src/app/models/notificacion/historial_notificacion.model';

@Injectable({
  providedIn: 'root'
})
export class HistorialNotificacionService extends BaseService {

    
    recordName = 'historial_notificaciones';

    url = `${ environment.host }/historial-notificacion`;

    codigoModulo = HistorialNotificacion.CODIGO_MODULO;
    codigoRegistro = HistorialNotificacion.CODIGO_REGISTRO;

    async guardarHistorialdeCorreo( body: Record<string, any>) {      
        let url = `${this.url}/historial-notificacion-correo`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    
    async enviarCorreo( body: Record<string, any>) {      
        let url = `${this.url}/enviar-correo`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async enviarMensaje( body: Record<string, any>) {      
        let url = `${this.url}/enviar-mensaje`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    
    async guardarHistorialdeMensaje( body: Record<string, any>) {
        let url = `${this.url}/historial-notificacion-mensaje`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async subirImagenCloudinary( body: Record<string, any>) {      
        let url = `${this.url}/subir-imagen-cloudinary`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body, { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    /**
     * Sube un archivo Excel/CSV para procesamiento masivo
     */
    async subirArchivoExcel(body: Record<string, any>) {
        let url = `${environment.host}/carga-masiva/subir-lista`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url, body, { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }

    /**
     * Obtiene el estado de una carga masiva
     */
    async getEstadoCarga(id_carga: number, id_empresa: number) {
        let url = `${environment.host}/carga-masiva/estado-carga/${id_carga}`;
        try {
            await this.updateToken();
            const headers = this.header;
            const params = { id_empresa };
            const resp = await lastValueFrom(this.http.get<any>(url, { headers: headers, params: params }));
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }

    /**
     * Obtiene los contactos de una carga masiva
     */
    async getContactosCarga(id_carga: number, id_empresa: number) {
        let url = `${environment.host}/carga-masiva/contactos/${id_carga}`;
        try {
            await this.updateToken();
            const headers = this.header;
            const params = { id_empresa };
            const resp = await lastValueFrom(this.http.get<any>(url, { headers: headers, params: params }));
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }
}